import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotDramas from './components/HotDramas';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotDramas />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "努努影院 - 免费电视剧高清电视剧全集",
          "description": "努努影院电视剧频道提供高清电视剧全集免费在线观看，最新剧集实时更新，播放不缓冲，流畅追剧首选。",
          "url": "https://nunumovie.com/",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "首页",
              "item": "https://nunumovie.com/"
            }]
          }
        })
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "努努影院是否需要注册才能观看？", "acceptedAnswer": { "@type": "Answer", "text": "不需要注册。努努影院所有电视剧资源均免费提供，无需注册账号即可直接在线观看。" } },
            { "@type": "Question", "name": "为什么努努影院播放不缓冲？", "acceptedAnswer": { "@type": "Answer", "text": "努努影院采用了先进的CDN加速技术和多线服务器部署，确保视频加载速度快、播放流畅。" } },
            { "@type": "Question", "name": "努努影院支持哪些设备观看？", "acceptedAnswer": { "@type": "Answer", "text": "努努影院全面支持电脑、平板、手机等多种设备，无论您使用Windows、Mac、iOS还是Android系统。" } },
            { "@type": "Question", "name": "电视剧更新频率是怎样的？", "acceptedAnswer": { "@type": "Answer", "text": "我们与各大视频平台保持同步更新，最新剧集上线后第一时间更新，热门电视剧通常在播出后数小时内即可观看。" } },
            { "@type": "Question", "name": "努努影院提供哪些类型的电视剧？", "acceptedAnswer": { "@type": "Answer", "text": "努努影院提供国产剧、韩剧、美剧、日剧、泰剧、动漫等多类型电视剧资源，满足不同观众的追剧需求。" } },
            { "@type": "Question", "name": "观看时出现卡顿怎么办？", "acceptedAnswer": { "@type": "Answer", "text": "如遇播放卡顿，建议您尝试切换清晰度或刷新页面，也可以联系在线客服获取帮助。" } }
          ]
        })
      }} />
    </>
  );
}